export const PANEL_BACKGROUNDS = {
  dark: [
    {
      key: 'midnight',
      label: 'Midnight',
      preview: 'linear-gradient(135deg, #0b0f14, #0f172a)',
      vars: { '--bg': '#0b0f14', '--bg2': '#0f172a', '--primary': '#8b5cf6', '--primary2': '#22c55e' },
    },
    {
      key: 'violet_nebula',
      label: 'Violet Nebula',
      preview: 'linear-gradient(135deg, #0b1020, #1a1033)',
      vars: { '--bg': '#0b1020', '--bg2': '#1a1033', '--primary': '#a78bfa', '--primary2': '#22c55e' },
    },
    {
      key: 'graphite',
      label: 'Graphite',
      preview: 'linear-gradient(135deg, #0b0f14, #111827)',
      vars: { '--bg': '#0b0f14', '--bg2': '#111827', '--primary': '#38bdf8', '--primary2': '#f59e0b' },
    },
    {
      key: 'aurora',
      label: 'Aurora',
      preview: 'linear-gradient(135deg, #07121c, #0b1a2b)',
      vars: { '--bg': '#07121c', '--bg2': '#0b1a2b', '--primary': '#22c55e', '--primary2': '#38bdf8' },
    },
    {
      key: 'ocean',
      label: 'Ocean',
      preview: 'linear-gradient(135deg, #07121c, #0b1d2b)',
      vars: { '--bg': '#07121c', '--bg2': '#0b1d2b', '--primary': '#0ea5e9', '--primary2': '#14b8a6' },
    },
    {
      key: 'deep_sea',
      label: 'Deep Sea',
      preview: 'linear-gradient(135deg, #06131a, #06202b)',
      vars: { '--bg': '#06131a', '--bg2': '#06202b', '--primary': '#38bdf8', '--primary2': '#22c55e' },
    },
    {
      key: 'ember',
      label: 'Ember',
      preview: 'linear-gradient(135deg, #120a0a, #1f1416)',
      vars: { '--bg': '#120a0a', '--bg2': '#1f1416', '--primary': '#f97316', '--primary2': '#ef4444' },
    },
    {
      key: 'copper',
      label: 'Copper',
      preview: 'linear-gradient(135deg, #140d08, #24160d)',
      vars: { '--bg': '#140d08', '--bg2': '#24160d', '--primary': '#fb923c', '--primary2': '#f59e0b' },
    },
    {
      key: 'forest',
      label: 'Forest',
      preview: 'linear-gradient(135deg, #07150f, #0b1f14)',
      vars: { '--bg': '#07150f', '--bg2': '#0b1f14', '--primary': '#22c55e', '--primary2': '#8b5cf6' },
    },
    {
      key: 'moss',
      label: 'Moss',
      preview: 'linear-gradient(135deg, #07140f, #12241a)',
      vars: { '--bg': '#07140f', '--bg2': '#12241a', '--primary': '#16a34a', '--primary2': '#a78bfa' },
    },
    {
      key: 'ink',
      label: 'Ink',
      preview: 'linear-gradient(135deg, #080b12, #0b1020)',
      vars: { '--bg': '#080b12', '--bg2': '#0b1020', '--primary': '#60a5fa', '--primary2': '#f472b6' },
    },
    {
      key: 'plum',
      label: 'Plum',
      preview: 'linear-gradient(135deg, #0d0712, #1e0f2a)',
      vars: { '--bg': '#0d0712', '--bg2': '#1e0f2a', '--primary': '#f472b6', '--primary2': '#a78bfa' },
    },
  ],
  light: [
    {
      key: 'lavender',
      label: 'Lavender',
      preview: 'linear-gradient(135deg, #f7f8fb, #eef2ff)',
      vars: { '--bg': '#f7f8fb', '--bg2': '#eef2ff', '--primary': '#6d28d9', '--primary2': '#16a34a' },
    },
    {
      key: 'rose_milk',
      label: 'Rose Milk',
      preview: 'linear-gradient(135deg, #fff1f2, #ffe4e6)',
      vars: { '--bg': '#fff1f2', '--bg2': '#ffe4e6', '--primary': '#be185d', '--primary2': '#2563eb' },
    },
    {
      key: 'peach',
      label: 'Peach',
      preview: 'linear-gradient(135deg, #fff7ed, #ffedd5)',
      vars: { '--bg': '#fff7ed', '--bg2': '#ffedd5', '--primary': '#ea580c', '--primary2': '#0284c7' },
    },
    {
      key: 'butter',
      label: 'Butter',
      preview: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
      vars: { '--bg': '#fffbeb', '--bg2': '#fef3c7', '--primary': '#b45309', '--primary2': '#0284c7' },
    },
    {
      key: 'mint',
      label: 'Mint',
      preview: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
      vars: { '--bg': '#f0fdf4', '--bg2': '#dcfce7', '--primary': '#16a34a', '--primary2': '#0ea5e9' },
    },
    {
      key: 'sage',
      label: 'Sage',
      preview: 'linear-gradient(135deg, #f0fdf4, #e2fbe7)',
      vars: { '--bg': '#f0fdf4', '--bg2': '#e2fbe7', '--primary': '#15803d', '--primary2': '#6d28d9' },
    },
    {
      key: 'sky',
      label: 'Sky',
      preview: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)',
      vars: { '--bg': '#f0f9ff', '--bg2': '#e0f2fe', '--primary': '#0284c7', '--primary2': '#6d28d9' },
    },
    {
      key: 'ice',
      label: 'Ice',
      preview: 'linear-gradient(135deg, #ecfeff, #cffafe)',
      vars: { '--bg': '#ecfeff', '--bg2': '#cffafe', '--primary': '#0e7490', '--primary2': '#7c3aed' },
    },
    {
      key: 'mono',
      label: 'Mono',
      preview: 'linear-gradient(135deg, #ffffff, #f1f5f9)',
      vars: { '--bg': '#ffffff', '--bg2': '#f1f5f9', '--primary': '#6d28d9', '--primary2': '#16a34a' },
    },
    {
      key: 'slate',
      label: 'Slate',
      preview: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
      vars: { '--bg': '#f8fafc', '--bg2': '#e2e8f0', '--primary': '#334155', '--primary2': '#6d28d9' },
    },
    {
      key: 'cotton',
      label: 'Cotton',
      preview: 'linear-gradient(135deg, #fdf2f8, #fae8ff)',
      vars: { '--bg': '#fdf2f8', '--bg2': '#fae8ff', '--primary': '#7c3aed', '--primary2': '#db2777' },
    },
    {
      key: 'spring',
      label: 'Spring',
      preview: 'linear-gradient(135deg, #ecfccb, #d9f99d)',
      vars: { '--bg': '#ecfccb', '--bg2': '#d9f99d', '--primary': '#3f6212', '--primary2': '#0284c7' },
    },
  ],
};

export function backgroundPresetsForTheme(themeMode) {
  const t = String(themeMode || '').toLowerCase();
  return PANEL_BACKGROUNDS[t] || PANEL_BACKGROUNDS.dark;
}

export function resolveBackgroundPreset(themeMode, presetKey) {
  const list = backgroundPresetsForTheme(themeMode);
  const key = String(presetKey || '').trim();
  return list.find((p) => p.key === key) || list[0] || null;
}

export function fontStack(fontKey) {
  const k = String(fontKey || '').toLowerCase();
  const base =
    "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
  if (k === 'inter') return `'Inter', ${base}`;
  return `'Space Grotesk', ${base}`;
}

export function applyAppearanceToDocument(appearance) {
  if (typeof document === 'undefined') return;
  const a = appearance && typeof appearance === 'object' ? appearance : null;
  if (!a) return;

  const themeMode = String(a.theme_mode || '').toLowerCase();
  if (themeMode === 'dark' || themeMode === 'light') {
    document.documentElement.setAttribute('data-theme', themeMode);
    try {
      window.localStorage.setItem('omniscope:theme', themeMode);
    } catch {
      // ignore
    }
  }

  const font = fontStack(a.font);
  document.documentElement.style.setProperty('--font', font);

  const presetKey = themeMode === 'light' ? a.background_preset_light : a.background_preset_dark;
  const preset = resolveBackgroundPreset(themeMode || 'dark', presetKey);
  const vars = preset?.vars || null;
  for (const k of ['--bg', '--bg2', '--primary', '--primary2']) {
    const v = vars && Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k] || '') : '';
    if (v) document.documentElement.style.setProperty(k, v);
  }
}
